
import PageTemplate from "./PageTemplate";
import Collapsible from "../components/Collapsible";

export default {
  render(h) {
    return (
      <PageTemplate>
        <div class="bg-secondary">
          <div class="container mx-auto px-3 lg:px-6 py-2 lg:py-3">
            <h1 class="text-2xl lg:text-3xl text-white">
              {this.$t("help_page.h1")}
            </h1>
          </div>
        </div>
        <div class="bg-secondary_light">
          <div class="container mx-auto px-3 lg:px-6 py-3 lg:py-5">
          <h3 class="text-lg lg:text-2xl text-blue-600 font-bold">
              {this.$t("help_page.frequently_asked_questions")}
            </h3>

            <ul class="mt-10 mb-10 lg:mb-0">
              {this.$t('help_page.faq').map(([q, a]) => (
                <li key={q}>
                  <Collapsible head={q} body={a} />
                </li>
              ))}
            </ul>
          </div>
        </div>

        
      </PageTemplate>
    );
  },
};

/**
 *
 * @type {{data(): *, methods: {toggle(): void}, render(*): *, props: string[]}}
 */
const Collapse = {
  props: ["head", "body", "first"],

  data() {
    return { open: false };
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },
  },

  render(h) {
    const icnClass = classNames("mdi text-blue-600 mr-3 leading-tight", {
      "mdi-plus-circle-outline": !this.open,
      "mdi-minus-circle-outline": this.open,
    });

    const eleClass = classNames("border-gray-200 border-t-4 py-6 lg:py-6", {
      "lg:border-0": this.first,
    });

    return (
      <div class={eleClass}>
        <div
          class="flex lg:items-center cursor-pointer select-none"
          onClick={this.toggle}
        >
          <i class={icnClass}></i>
          <p class="font-bold text-sm lg:text-base">{this.head}</p>
        </div>
        {this.open && (
          <p
            class="text-xs lg:text-sm lg:w-9/12 py-3"
            domPropsInnerHTML={this.body}
          ></p>
        )}
      </div>
    );
  },
};
